import { Offcanvas, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import "quill-better-table/dist/quill-better-table.css";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { AddCommentInterface } from "./testiMonial";
import HelperService from "../../utility/HelperService";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill-new";
import { Upload } from "lucide-react";
import { quillImageHandler } from "../../utility/quilImageHandler";
import CommonQuill from "../../components/editor/CommonQuill";

interface PropData {
  show: boolean;
  handleClose: () => void;
  data: AddCommentInterface | null;
}
const AddBanner = (props: PropData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    trigger
  } = useForm<AddCommentInterface & { role?: string }>();
  const [isLoading, setLoading] = useState(false);
  const [bladeTitle, setBladeTitle] = useState("");
  const [selectedUser, setSelectedUser] = useState<AddCommentInterface | null>(
    null
  );
  const [value, setEditorValue] = useState("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [file, setFile] = useState<File | null>(null);
  const quillRef = useRef<any>(null);
  const [customErrors, setCustomErrors] = useState<{
    comment?: string;
  }>({});
  useEffect(() => {
    if (props.data) {
      setBladeTitle("Edit Testimonial");
      reset(props.data);
      setEditorValue(props.data?.comment || "");
    } else {
      reset({});
      setBladeTitle("Add Testimonial");
      setEditorValue("");
    }
  }, [props.show]);
  const isQuillEmpty = (value?: string) => {
    if (!value) return true;

    // remove html tags, &nbsp; and spaces
    const text = value
      .replace(/<(.|\n)*?>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };
  const validateInfoTab = async () => {
    const titleValid = await trigger(["userName"]);

    const newErrors: any = {};

    if (isQuillEmpty(value)) {
      newErrors.comment = "Comment is required";
    }

    setCustomErrors(newErrors);

    // 🔥 IMPORTANT: return actual validity
    return titleValid && !newErrors.description;
  };
  const data = props.data;
  const onSubmit = async (requestBody: AddCommentInterface) => {
       const valid = await validateInfoTab();
    if (!valid) {
      toast.error("Please fill required fields");
      return;
    }
    setLoading(true);

    const editor = quillRef.current?.getEditor();
    const html = editor?.root.innerHTML || "";

    // Attach Quill comment value
    const payload = {
      ...requestBody,
      comment: html,
    };

    // Correct update/create API
    const apiCall = props.data?._id
      ? WebService.putAPI({
          action: `testiMonial/update/${props.data._id}`,
          body: payload,
        })
      : WebService.postAPI({
          action: `testiMonial/add`,
          body: payload,
        });

    apiCall
      .then((res: any) => {
        toast.success(
          props.data?._id
            ? "Testimonial Updated Successfully."
            : "Testimonial Created Successfully."
        );
        setLoading(false);
        handleClose();
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message ||
            "Something went wrong. Please try again later."
        );
        setLoading(false);
      });
  };

  const handleClose = props.handleClose;
  const show = props.show;

  const onCloseModal = (e?: any) => {
    reset({});
    props.handleClose();
  };
  const imageHandler = () => {
    // alert("g");
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.onchange = async () => {
      const file = input.files?.[0];
      console.log("fileeeee", file);
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("storage", "ABOUT_US");

      try {
        const res: any = await WebService.fileUploadAPI({
          action: "upload",
          body: formData,
        });

        const imageUrl = res?.data?.url; // ✅ correct access

        if (!imageUrl) {
          toast.error("Image upload failed");
          return;
        }

        if (!quillRef.current) return;
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection(true);

        editor.insertEmbed(range.index, "image", imageUrl);
        editor.setSelection(range.index + 1);
      } catch (err) {
        toast.error("Image upload failed");
      }
    };
  };
  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          reset();
          onCloseModal();
        }}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{bladeTitle}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Name */}
            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                User Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                {...register("userName", { required: "Please enter name" })}
              />
              {errors.userName && (
                <div className="error-message">{errors.userName.message}</div>
              )}
            </Form.Group>

            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                User Details <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter user details"
                {...register("userCompany", {
                  required: "Please enter users details",
                })}
              />
              {errors.userCompany && (
                <div className="error-message">
                  {errors.userCompany.message}
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-2" controlId="eventName">
              <Form.Label className="label">
                Comment <span className="text-danger">*</span>
              </Form.Label>
              {/* <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={setEditorValue}
                className="editor"
                modules={{
                  toolbar: {
                    container: [
                      ["bold", "italic", "underline"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ indent: "-1" }, { indent: "+1" }],
                      [{ size: ["small", false, "large"] }],
                      [{ color: [] }, { background: [] }],
                      ["link", "image"],
                      ["clean"],
                    ],
                    handlers: {
                      image: () =>
                        quillImageHandler({
                          quillRef,
                          storage: "ABOUT_US",
                        }),
                    },
                  },
                
                }}
              />
              {errors.comment && (
                <div className="error-message">{errors.comment.message}</div>
              )} */}
              <CommonQuill
                ref={quillRef}
                value={value}
                onChange={setEditorValue}
                storage="ABOUT_US"
                initialHtml={show && data?.comment ? HelperService.normalizeResizeHtml(data.comment)  : undefined}
                onClearError={() =>
                  setCustomErrors((p) => ({
                    ...p,
                    comment: undefined,
                  }))
                }
              />
              {customErrors.comment && (
                <div className="error-message">{customErrors.comment}</div>
              )}
            </Form.Group>

            <div className="d-flex justify-content-end p-3">
              <CustomButton
                isLoading={isLoading}
                label="Save"
                className="w-100"
                type="submit"
                id="saveUserButton"
              />
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AddBanner;
